import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonResponsiveWrapper, costFormater, Preloader, useResponsive } from '@common-fe/common-fe';
import _ from 'lodash';

import AppButton from '@/components/controls/AppButton';
import { PendingModal } from '@/components/elements';

const BUTTON_WIDTH = '130px';

interface Props {
  visible: boolean;
  fundingAmount: string;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}
const ConfirmSellModal: React.FC<Props> = ({ visible, fundingAmount, onSetVisible, onSubmit, isLoading }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const handleSubmit = useCallback(() => {
    if (isLoading) {
      return;
    }
    onSubmit();
    onSetVisible(false);
  }, [isLoading, onSetVisible, onSubmit]);

  return (
    <PendingModal
      testId="confirm-sell"
      header={t(`Submit a trade settlement for ${costFormater(_.toNumber(fundingAmount), true)}?`)}
      helptext={t('Trade settlement may take up to 2 days.')}
      visible={visible}
      onSetVisible={onSetVisible}
    >
      <ButtonResponsiveWrapper fill={isMobile}>
        <AppButton
          fill={isMobile}
          testId="confirm-sell-modal_cancel"
          buttonType="secondary"
          onClick={() => onSetVisible(false)}
          width={BUTTON_WIDTH}
        >
          {t('Cancel')}
        </AppButton>

        <AppButton
          fill={isMobile}
          testId="confirm-sell-modal_confirm"
          onClick={handleSubmit}
          width={BUTTON_WIDTH}
        >
          {isLoading ? <Preloader /> : t('Confirm')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </PendingModal>
  );
};

export default ConfirmSellModal;
